module.exports = __webpack_public_path__ + "static/img/jc4.83c12ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/jc4.png
// module id = mzDk
// module chunks = 1